import React, { useState } from 'react';
import { Nav, Accordion } from 'react-bootstrap';
import { 
  FaTachometerAlt, 
  FaMapMarkedAlt, 
  FaUserPlus, 
  FaTruck, 
  FaExclamationTriangle, 
  FaRulerCombined, 
  FaWeightHanging,
  FaPenSquare,
  FaStickyNote,
  FaChartLine,
  FaWeixin,
  FaExclamationCircle,
  FaChartBar  
} from 'react-icons/fa';
import './NavbarAdminComponent.css'; // Đảm bảo CSS được import

const NavbarAdminComponent = ({ setComponentDuocChon, isSidebarOpen, toggleSidebar }) => {
  const [activeLink, setActiveLink] = useState('baoDuongSuaChua'); // Quản lý trạng thái active của link

  // Xử lý khi chọn link và đóng sidebar trên mobile
  const handleLinkClick = (component) => {
    setActiveLink(component);
    setComponentDuocChon(component);

    // Đóng sidebar trên mobile
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  return (
    <div
      id="navbar-sidebar"
      className={`bg-white vh-100 p-1 pt-3 border-end shadow-sm ${isSidebarOpen ? 'show' : ''}`}
      style={{
        width: window.innerWidth > 768 ? '16.67%' : isSidebarOpen ? '60%' : '0', // Sidebar luôn hiển thị trên desktop (2/12), toggle trên mobile (60%)
        height: '100vh',
        position: window.innerWidth > 768 ? 'fixed' : 'absolute', // Fixed trên desktop, absolute trên mobile
        top: '80px', // Đẩy xuống dưới header
        left: 0,
        zIndex: 999, // Đảm bảo sidebar luôn trên cùng khi mở
        transition: 'transform 0.4s ease, opacity 0.4s ease', // Hiệu ứng khi mở/đóng
        transform: isSidebarOpen || window.innerWidth > 768 ? 'translateX(0)' : 'translateX(-100%)',
        opacity: isSidebarOpen || window.innerWidth > 768 ? 1 : 0,
      }}
    >
      <Accordion defaultActiveKey="0" flush className="flex-grow-1">
        {/* Quản Lý */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>
          <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Quản Lý</span>
            </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'baoDuongSuaChua' ? 'active' : ''}`}
                onClick={() => handleLinkClick('baoDuongSuaChua')}
                style={{
                  color: activeLink === 'baoDuongSuaChua' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'baoDuongSuaChua' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTruck className="me-2" /> Sửa Chữa - Bảo Dưỡng
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* Thêm Thông Tin */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>
          <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Thêm Thông Tin</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'createAccount' ? 'active' : ''}`}
                onClick={() => handleLinkClick('createAccount')}
                style={{
                  color: activeLink === 'createAccount' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'createAccount' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaUserPlus className="me-2" /> Tạo Tài Khoản
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'xeKinhDoanh' ? 'active' : ''}`}
                onClick={() => handleLinkClick('xeKinhDoanh')}
                style={{
                  color: activeLink === 'xeKinhDoanh' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'xeKinhDoanh' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTruck className="me-2" /> Chi Tiết Xe Kinh Doanh
              </Nav.Link>
              
              
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* Cảnh Báo Nhập Sai */}
        <Accordion.Item eventKey="2">
          <Accordion.Header >
          <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Cảnh Báo Nhập Sai</span>
            </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'missingTrip' ? 'active' : ''}`}
                onClick={() => handleLinkClick('missingTrip')}
                style={{
                  color: activeLink === 'missingTrip' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'missingTrip' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaExclamationTriangle className="me-2" /> Các Mã Chuyến Thiếu
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'wrongKm' ? 'active' : ''}`}
                onClick={() => handleLinkClick('wrongKm')}
                style={{
                  color: activeLink === 'wrongKm' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'wrongKm' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaRulerCombined className="me-2" /> Sai KM Đầu Cuối
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'wrongWeight' ? 'active' : ''}`}
                onClick={() => handleLinkClick('wrongWeight')}
                style={{
                  color: activeLink === 'wrongWeight' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'wrongWeight' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaWeightHanging className="me-2" /> Sai Trọng Lượng
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* Báo cáo */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>
              <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Báo cáo</span>
            </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'timTheoBKS' ? 'active' : ''}`}
                onClick={() => handleLinkClick('timTheoBKS')}
                style={{
                  color: activeLink === 'timTheoBKS' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'timTheoBKS' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTruck className="me-2" /> Tìm Theo BKS
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'loTrinhNhap' ? 'active' : ''}`}
                onClick={() => handleLinkClick('loTrinhNhap')}
                style={{
                  color: activeLink === 'loTrinhNhap' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'loTrinhNhap' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaPenSquare className="me-2" /> Lộ Trình Nhập
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'baoCaoDoanhThuKD' ? 'active' : ''}`}
                onClick={() => handleLinkClick('baoCaoDoanhThuKD')}
                style={{
                  color: activeLink === 'baoCaoDoanhThuKD' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'baoCaoDoanhThuKD' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaChartLine className="me-2" /> Báo Cáo Chuyến KD
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* Phòng Kinh Doanh */}
        <Accordion.Item eventKey="4">
          <Accordion.Header>
          <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Phòng Kinh Doanh</span>
            </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'taoChuyenKinhDoanh' ? 'active' : ''}`}
                onClick={() => handleLinkClick('taoChuyenKinhDoanh')}
                style={{
                  color: activeLink === 'taoChuyenKinhDoanh' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'taoChuyenKinhDoanh' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaPenSquare className="me-2" /> Tạo Chuyến Kinh Doanh
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'ganChuyenKinhDoanh' ? 'active' : ''}`}
                onClick={() => handleLinkClick('ganChuyenKinhDoanh')}
                style={{
                  color: activeLink === 'ganChuyenKinhDoanh' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'ganChuyenKinhDoanh' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTruck className="me-2" /> Gán Chuyến Kinh Doanh
                </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'taoKhachHangMoi' ? 'active' : ''}`}
                onClick={() => handleLinkClick('taoKhachHangMoi')}
                style={{
                  color: activeLink === 'taoKhachHangMoi' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'taoKhachHangMoi' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTruck className="me-2" /> Thêm Khách Hàng Mới
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'trangThaiChuyenDaTao' ? 'active' : ''}`}
                onClick={() => handleLinkClick('trangThaiChuyenDaTao')}
                style={{
                  color: activeLink === 'trangThaiChuyenDaTao' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'trangThaiChuyenDaTao' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaStickyNote className="me-2" /> Trạng Thái Chuyến
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'duLieuKD' ? 'active' : ''}`}
                onClick={() => handleLinkClick('duLieuKD')}
                style={{
                  color: activeLink === 'duLieuKD' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'duLieuKD' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaChartBar className="me-2" /> Lấy dữ liệu chuyến KD
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'tinNhanKhachHang' ? 'active' : ''}`}
                onClick={() => handleLinkClick('tinNhanKhachHang')}
                style={{
                  color: activeLink === 'tinNhanKhachHang' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'tinNhanKhachHang' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaWeixin className="me-2" /> Tin nhắn khách hàng
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'tongHopChuyenKDHoanTat' ? 'active' : ''}`}
                onClick={() => handleLinkClick('tongHopChuyenKDHoanTat')}
                style={{
                  color: activeLink === 'tongHopChuyenKDHoanTat' ? '#dc3545' : 'red',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'tongHopChuyenKDHoanTat' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaExclamationCircle className="me-2" /> Chuyến KD Tài xế Nhập Sai
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default NavbarAdminComponent;
